export const strings = {
  en: {
    title: ({ causeName = "" }) => `Your Subscription is Going Towards ${causeName} With Every Order`,
    futureTenseTitle: ({ causeName = "" }) => `Your Subscription Will Go Towards ${causeName} With Every Order`,
    ctaMessagePrefix: () => `At no extra cost, `,
    description: ({ nonprofit = "" }) => `1% of every order will be donated to ${nonprofit} on your behalf.`,
    personalImpactTitle: () => `You're Currently Funding`,
    futureTensePersonalImpactTitle: () => `You’ll Be Funding`,
    communityImpactTitle: () => `Together We're Funding`,
    personalLinkCopy: ({ nonprofit = "" }) => `Learn about ${nonprofit} ›`,
    communityLinkCopy: ({ brandName = "" }) => `Learn about ${brandName} ›`,
    percentFunded: () => `funded`,
    progressPillText: () => `🎉 Impact begins once order is charged`,
  },
  fr: {
    title: ({ causeName = "" }) => `Your Subscription is Going Towards ${causeName} With Every Order`,
    futureTenseTitle: ({ causeName = "" }) => `Your Subscription Will Go Towards ${causeName} With Every Order`,
    ctaMessagePrefix: () => `At no extra cost, `,
    description: ({ nonprofit = "" }) => `1% of every order will be donated to ${nonprofit} on your behalf.`,
    personalImpactTitle: () => `You're Currently Funding`,
    futureTensePersonalImpactTitle: () => `You’ll Be Funding`,
    communityImpactTitle: () => `Together We're Funding`,
    personalLinkCopy: ({ nonprofit = "" }) => `Learn about ${nonprofit} ›`,
    communityLinkCopy: ({ brandName = "" }) => `Learn about ${brandName} ›`,
    percentFunded: () => `funded`,
    progressPillText: () => `🎉 Impact begins once order is charged`,
  },
  de: {
    title: ({ causeName = "" }) => `Your Subscription is Going Towards ${causeName} With Every Order`,
    futureTenseTitle: ({ causeName = "" }) => `Your Subscription Will Go Towards ${causeName} With Every Order`,
    ctaMessagePrefix: () => `At no extra cost, `,
    description: ({ nonprofit = "" }) => `1% of every order will be donated to ${nonprofit} on your behalf.`,
    personalImpactTitle: () => `You're Currently Funding`,
    futureTensePersonalImpactTitle: () => `You’ll Be Funding`,
    communityImpactTitle: () => `Together We're Funding`,
    personalLinkCopy: ({ nonprofit = "" }) => `Learn about ${nonprofit} ›`,
    communityLinkCopy: ({ brandName = "" }) => `Learn about ${brandName} ›`,
    percentFunded: () => `funded`,
    progressPillText: () => `🎉 Impact begins once order is charged`,
  },
  es: {
    title: ({ causeName = "" }) => `Your Subscription is Going Towards ${causeName} With Every Order`,
    futureTenseTitle: ({ causeName = "" }) => `Your Subscription Will Go Towards ${causeName} With Every Order`,
    ctaMessagePrefix: () => `At no extra cost, `,
    description: ({ nonprofit = "" }) => `1% of every order will be donated to ${nonprofit} on your behalf.`,
    personalImpactTitle: () => `You're Currently Funding`,
    futureTensePersonalImpactTitle: () => `You’ll Be Funding`,
    communityImpactTitle: () => `Together We're Funding`,
    personalLinkCopy: ({ nonprofit = "" }) => `Learn about ${nonprofit} ›`,
    communityLinkCopy: ({ brandName = "" }) => `Learn about ${brandName} ›`,
    percentFunded: () => `funded`,
    progressPillText: () => `🎉 Impact begins once order is charged`,
  },
  it: {
    title: ({ causeName = "" }) => `Your Subscription is Going Towards ${causeName} With Every Order`,
    futureTenseTitle: ({ causeName = "" }) => `Your Subscription Will Go Towards ${causeName} With Every Order`,
    ctaMessagePrefix: () => `At no extra cost, `,
    description: ({ nonprofit = "" }) => `1% of every order will be donated to ${nonprofit} on your behalf.`,
    personalImpactTitle: () => `You're Currently Funding`,
    futureTensePersonalImpactTitle: () => `You’ll Be Funding`,
    communityImpactTitle: () => `Together We're Funding`,
    personalLinkCopy: ({ nonprofit = "" }) => `Learn about ${nonprofit} ›`,
    communityLinkCopy: ({ brandName = "" }) => `Learn about ${brandName} ›`,
    percentFunded: () => `funded`,
    progressPillText: () => `🎉 Impact begins once order is charged`,
  },
  pl: {
    title: ({ causeName = "" }) => `Your Subscription is Going Towards ${causeName} With Every Order`,
    futureTenseTitle: ({ causeName = "" }) => `Your Subscription Will Go Towards ${causeName} With Every Order`,
    ctaMessagePrefix: () => `At no extra cost, `,
    description: ({ nonprofit = "" }) => `1% of every order will be donated to ${nonprofit} on your behalf.`,
    personalImpactTitle: () => `You're Currently Funding`,
    futureTensePersonalImpactTitle: () => `You’ll Be Funding`,
    communityImpactTitle: () => `Together We're Funding`,
    personalLinkCopy: ({ nonprofit = "" }) => `Learn about ${nonprofit} ›`,
    communityLinkCopy: ({ brandName = "" }) => `Learn about ${brandName} ›`,
    percentFunded: () => `funded`,
    progressPillText: () => `🎉 Impact begins once order is charged`,
  },
};
